module.exports = __webpack_public_path__ + "static/media/asap.0eed18ba.png";